import { client } from '../../utils/apiClients';

export const archiveActivity = async (id: number) => client.post(`activity/${id}/archive/`);
export const unarchiveActivity = async (id: number) => client.post(`activity/${id}/unarchive/`);
